export const FETCH_TAXDETAILS_BEGIN="FETCH_TAXDETAILS_BEGIN";
export const FETCH_TAXDETAILS_SUCCESS="FETCH_TAXDETAILS_SUCCESS";
export const FETCH_TAXDETAILS_FAILURE = "FETCH_TAXDETAILS_FAILURE";

export const FETCH_TAXENTITYCONTACTS_BEGIN = "FETCH_TAXENTITYCONTACTS_BEGIN";
export const FETCH_TAXENTITYCONTACTS_SUCCESS = "FETCH_TAXENTITYCONTACTS_SUCCESS";
export const FETCH_TAXENTITYCONTACTS_FAILURE = "FETCH_TAXENTITYCONTACTS_FAILURE";


export const FETCH_TAXENTITYCONTACTACCESS_BEGIN = "FETCH_TAXENTITYCONTACTACCESS_BEGIN";
export const FETCH_TAXENTITYCONTACTACCESS_SUCCESS = "FETCH_TAXENTITYCONTACTACCESS_SUCCESS";
export const FETCH_TAXENTITYCONTACTACCESS_FAILURE = "FETCH_TAXENTITYCONTACTACCESS_FAILURE";

export const FETCH_GETCONTACTROLEACCESS_BEGIN = "FETCH_GETCONTACTROLEACCESS_BEGIN";
export const FETCH_GETCONTACTROLEACCESS_SUCCESS = "FETCH_GETCONTACTROLEACCESS_SUCCESS";
export const FETCH_GETCONTACTROLEACCESS_FAILURE = "FETCH_GETCONTACTROLEACCESS_FAILURE";


export const FETCH_GETCONTACTROLE_BEGIN = "FETCH_GETCONTACTROLE_BEGIN";
export const FETCH_GETCONTACTROLE_SUCCESS = "FETCH_GETCONTACTROLE_SUCCESS";
export const FETCH_GETCONTACTROLE_FAILURE = "FETCH_GETCONTACTROLE_FAILURE";


